import React, {Fragment, useState} from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import {flattenEdges} from '../../../utils/graphql';
import {ASH, WHITE, GUNSMOKE, CHARCOAL} from '../../../style/colors';
import {BASE_TEXT, WEIGHT} from '../../../style/typography';
import Gutter from './gutter';
import {PHONE} from '../../../style/breakpoints';
import StackAdviceCard from './stack-advice-card';

const Toggle = glamorous.div({
  ...BASE_TEXT,
  color: CHARCOAL,
  backgroundColor: WHITE,
  border: `1px solid ${GUNSMOKE}`,
  padding: '3px 7px 3px 7px',
  borderRadius: 100,
  marginTop: 12,
  width: 115,
  textAlign: 'center',
  cursor: 'pointer',
  letterSpacing: 0.4,
  alignSelf: 'center'
});

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: WHITE,
  borderTop: `1px solid ${ASH}`,
  padding: 10,
  paddingTop: 26,
  paddingBottom: 30,
  [PHONE]: {
    padding: 8
  },
  ' > div': {
    [PHONE]: {
      width: '100%'
    },
    ' > article ': {
      width: '100%',
      flexGrow: 1,
      marginBottom: 20,
      marginRight: 0,
      border: `1px solid ${ASH}`,
      borderBottom: 0,
      boxShadow: '0 2px 6px 0 rgba(227, 227, 227, 0.5)'
    }
  },
  ' > div:last-of-type': {
    ' > article': {
      marginBottom: 0
    }
  }
});

const Count = glamorous.div({
  ...BASE_TEXT,
  fontWeight: WEIGHT.BOLD,
  fontSize: 14,
  color: CHARCOAL,
  letterSpacing: 0.23,
  marginLeft: 14,
  marginBottom: 10,
  ' > span': {
    fontWeight: WEIGHT.NORMAL
  }
});

const PostCardWrapper = glamorous.div({
  display: 'flex'
});

const HiddenPostCardWrapper = glamorous.div({
  display: 'none'
});

const Answers = ({itemsData}) => {
  const {count: displayCount} = itemsData;
  const items = flattenEdges(itemsData);
  const [answersToDisplay, setAnswersToDisplay] = useState(displayCount);

  const fetchData = () => {
    setAnswersToDisplay(items.length);
  };

  return (
    <Fragment>
      {items.length > 0 && (
        <Container>
          {items.length > 0 && (
            <Count>
              Replies <span>{`(${displayCount})`}</span>
            </Count>
          )}
          {items.slice(0, answersToDisplay).map((item, index) => (
            <PostCardWrapper key={item.id}>
              <Gutter last={index + 1 === answersToDisplay} />
              <StackAdviceCard
                {...item}
                position={index + 1}
                publicId={item.publicId}
                user={item.user}
                publishedAt={item.publishedAt}
                upvotesCount={item.upvotesCount}
                viewCount={item.viewCount}
                htmlContent={item.htmlContent}
                services={item.services}
                topics={item.topics}
                company={item.company}
                link={item.link}
              />
            </PostCardWrapper>
          ))}
          <HiddenPostCardWrapper>
            {items.slice(answersToDisplay).map((item, index) => (
              <PostCardWrapper key={item.id}>
                <Gutter last={index + 1 === answersToDisplay} />
                <StackAdviceCard
                  {...item}
                  position={index + 1}
                  publicId={item.publicId}
                  user={item.user}
                  publishedAt={item.publishedAt}
                  upvotesCount={item.upvotesCount}
                  viewCount={item.viewCount}
                  htmlContent={item.htmlContent}
                  services={item.services}
                  topics={item.topics}
                  company={item.company}
                  link={item.link}
                />
              </PostCardWrapper>
            ))}
          </HiddenPostCardWrapper>
          {items.length > answersToDisplay && (
            <Toggle onClick={() => fetchData()}>{`View all (${displayCount})`}</Toggle>
          )}
        </Container>
      )}
    </Fragment>
  );
};

Answers.propTypes = {
  itemsData: PropTypes.object
};

export default Answers;
